import { memo } from 'react';
import { Modal } from 'antd';

import { ModalLeavePromptProps } from './types';

const ModalLeavePrompt = ({ modal, handleConfirm, handleCancel }: ModalLeavePromptProps) => (
  <Modal
    visible={modal.visible}
    title='Leave this page'
    okText='Confirm'
    onOk={handleConfirm}
    onCancel={handleCancel}
    zIndex={1001}
  >
    There are unsaved changes. Are you sure want to leave this page ?
  </Modal>
);

export default memo(ModalLeavePrompt);
